var _ellipse, _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 113,
    viewBox: "0 0 164 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.05,
    cx: 78.076,
    cy: 49.7488,
    rx: 78.076,
    ry: 49.7488,
    transform: "matrix(-0.915086 -0.403258 -0.403298 0.915069 173.52 42.9695)",
    fill: "#72A4FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_941_1617)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 32,
    width: 89,
    height: 48,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.75,
    y: 32.25,
    width: 88.5,
    height: 47.5,
    rx: 3.75,
    stroke: "#F2F2F2",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.5 44C120.052 44 120.5 43.5523 120.5 43L120.5 39C120.5 38.4477 120.052 38 119.5 38L99.5 38C98.9477 38 98.5 38.4477 98.5 39L98.5 43C98.5 43.5523 98.9477 44 99.5 44L119.5 44Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5 44C89.0523 44 89.5 43.5523 89.5 43L89.5 39C89.5 38.4477 89.0523 38 88.5 38L44.5 38C43.9477 38 43.5 38.4477 43.5 39L43.5 43C43.5 43.5523 43.9477 44 44.5 44L88.5 44Z",
    fill: "#C4D9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.5 58C120.052 58 120.5 57.5523 120.5 57L120.5 55C120.5 54.4477 120.052 54 119.5 54L108.5 54C107.948 54 107.5 54.4477 107.5 55L107.5 57C107.5 57.5523 107.948 58 108.5 58L119.5 58Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5 58C103.052 58 103.5 57.5523 103.5 57L103.5 55C103.5 54.4477 103.052 54 102.5 54L44.5 54C43.9477 54 43.5 54.4477 43.5 55L43.5 57C43.5 57.5523 43.9477 58 44.5 58L102.5 58Z",
    fill: "#E3ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5 66C83.0523 66 83.5 65.5523 83.5 65L83.5 63C83.5 62.4477 83.0523 62 82.5 62L44.5 62C43.9477 62 43.5 62.4477 43.5 63L43.5 65C43.5 65.5523 43.9477 66 44.5 66L82.5 66Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.5 74C120.052 74 120.5 73.5523 120.5 73L120.5 71C120.5 70.4477 120.052 70 119.5 70L44.5 70C43.9477 70 43.5 70.4477 43.5 71L43.5 73C43.5 73.5523 43.9477 74 44.5 74L119.5 74Z",
    fill: "#F6F6F6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.05 70.5889L105.795 74.2333L109.543 70.5889M105.337 73.3222C105.269 72.7239 105.234 72.1159 105.234 71.5C105.234 62.4425 112.782 55.1 122.092 55.1C131.403 55.1 138.95 62.4425 138.95 71.5C138.95 80.5575 131.403 87.9 122.092 87.9C116.797 87.9 112.071 85.5244 108.981 81.8089M122.092 62.3889V71.5L128.274 75.1444",
    stroke: "#C4D9FE",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_941_1617",
    x: 33.5,
    y: 32,
    width: 97,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_941_1617"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_941_1617",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.f14d9716.svg";
export { ForwardRef as ReactComponent };